<template>
  <b-overlay>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12">
              <SchedulesHistory :isForAdmin="false"></SchedulesHistory>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    // this.getAllUsers();
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {
    BCard,
    BRow,
    BCol,
    BLink,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BOverlay,
    SchedulesHistory,
  },
};
import SchedulesHistory from "@/views/components/Schedule/SchedulesHistory.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BTable,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
